// Luxury Variant Picker Handler

function getLuxuryVariantImageForViewport(element) {
  if (
    window.matchMedia('(max-width: 749px)').matches &&
    element.dataset.variantImageMobile
  ) {
    return element.dataset.variantImageMobile;
  }

  return element.dataset.variantImage;
}


document.addEventListener('DOMContentLoaded', function() {
  // Set initial selected color for each card on page load
  document.querySelectorAll('.luxury-variant-picker--bottom').forEach(picker => {
    const activeItem = picker.querySelector('.luxury-variant-item.active');
    if (activeItem) {
      const card = picker.closest('.card-wrapper, .collection-card-wrapper');
      const colorName = activeItem.dataset.colorName;
      if (card && colorName) {
        card.setAttribute('data-selected-color', colorName);

      }
    }
  });

  // Handle variant item clicks
  document.addEventListener('click', function(e) {
    const variantItem = e.target.closest('.luxury-variant-item');
    if (!variantItem) return;

    // Don't process if unavailable
    if (variantItem.classList.contains('unavailable')) {
      e.preventDefault();
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const card = variantItem.closest('.card-wrapper, .collection-card-wrapper');
    const variantImage = getLuxuryVariantImageForViewport(variantItem);
    const variantColor = variantItem.dataset.colorName;
    const variantId = variantItem.dataset.variantId;

    // Update active state
    const allVariants = variantItem.closest('.luxury-variant-picker').querySelectorAll('.luxury-variant-item');
    allVariants.forEach(item => item.classList.remove('active'));
    variantItem.classList.add('active');

    // Store selected color in card's data attribute for size selector to read
    if (card) {
      card.setAttribute('data-selected-color', variantColor);

    }

    // Update main product image with smooth transition
    if (variantImage && card) {
      const mainImage = card.querySelector('.card__media img:first-child, .collection-card__media-wrapper img:first-child');
      if (mainImage) {
        // Add transition class
        mainImage.style.transition = 'opacity 0.3s ease';
        mainImage.style.opacity = '0';

        setTimeout(() => {
          mainImage.src = variantImage;
          mainImage.srcset = variantImage;

          // Fade back in
          setTimeout(() => {
            mainImage.style.opacity = '1';
          }, 50);
        }, 300);
      }
    }

    // Update the color swatches below if they exist
    const colorSwatches = card.querySelectorAll('.product-card-color-selector .color-swatch-button');
    if (colorSwatches.length > 0) {
      colorSwatches.forEach(swatch => {
        if (swatch.dataset.colorValue === variantColor ||
            swatch.title === variantColor) {
          swatch.classList.add('active');
        } else {
          swatch.classList.remove('active');
        }
      });
    }

  });
});
